<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title>
      <img src="assets/imgs/header-icon.png" height="25" class="title-icon"/>
      growcoco - {{activeSite}}
    </ion-title>
    <ion-buttons slot="primary">
      <ion-button (click)="openAbout()">
        <ion-icon slot="icon-only" name="information-circle-outline"></ion-icon>
      </ion-button>
    </ion-buttons>

  </ion-toolbar>
  <ion-tab-bar *ngIf="!isMobile" translucent="true" class="no-border">
    <ion-tab-button tab="batami" layout="icon-start" [selected]="activeSite === 'batami'">
      <ion-icon name="leaf"></ion-icon>
      <ion-label>batami</ion-label>
    </ion-tab-button>
    <ion-tab-button tab="forest" layout="icon-start" [selected]="activeSite === 'forest'">
      <ion-icon name="compass"></ion-icon>
      <ion-label>forest</ion-label>
    </ion-tab-button>
  </ion-tab-bar>
</ion-header>
<audio src="/assets/forest.mp3" loop autoplay hidden>
  <p>If you are reading this, it is because your browser does not support the audio element.     </p>
</audio>
